import React, { ChangeEventHandler, useContext, useState } from "react";
import * as Yup from "yup";
import { CreateArtifactContext } from "../../../../../context/CreateArtifactContext";
import { ContentState } from "../../../../../models/SKArtifact";

interface SKURLWidgetProps {
  id?: string;
  name?: string;
  title?: string;
  note?: string;
  placeholder: string;
  index?: number;
  charAllowed: number;
  isCloseBtn?: boolean;
  value?: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
  onClose?: (index: number) => void;
}

export const SKURLWidget = ({
  id,
  name,
  title,
  note,
  placeholder,
  charAllowed,
  onClose,
  index,
  value = "",
  onChange,
  isCloseBtn = false,
}: SKURLWidgetProps) => {
  const { contentData } = useContext(CreateArtifactContext);
  const [error, setError] = useState<string>("");

  const urlSchema = Yup.string()
    .matches(/^(https?:\/\/)?([a-zA-Z\d-]+\.){1,2}[a-zA-Z]{2,}$/, "URL must include a valid protocol, domain, and domain extension")
    .required("URL is required");

  const handleFocus = (e: React.FocusEvent<HTMLInputElement>) => {
    if (!value) {
      onChange({
        ...e,
        target: { ...e.target, value: "https://www." },
      } as any);
    }
  };

  const handleBlur = async (e: React.FocusEvent<HTMLInputElement>) => {
    try {
      await urlSchema.validate(e.target.value);
      setError("");
    } catch (err: any) {
      setError(err.message);
    }
  };

  const removeItem = () => {
    if (onClose && index !== undefined) {
      onClose(index);
    }
  };

  return (
    <>
      <div className="relative w-full min-w-[200px] mb-2">
        <div className="flex items-center space-x-2">
          {name && <div className="flex items-center justify-center w-5 h-5 text-sm text-black border-2 border-black rounded-full">{index}</div>}
          <span className="text-lg font-bold">{title}</span>
        </div>
        <p className="mb-4 text-sm text-gray-400">{note}</p>

        <div className="flex items-center">
          <input
            type="text"
            name={name}
            id={id}
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder={placeholder}
            required
            maxLength={charAllowed}
            value={value}
            onChange={onChange}
            onFocus={handleFocus}
            onBlur={handleBlur}
          />
          {isCloseBtn && contentData.status !== ContentState.IN_REVIEW && (
            <button
              id="removeItem"
              className="ml-2"
              onClick={e => {
                e.stopPropagation();
                removeItem();
              }}
            >
              <img src="/icons/CloseButton.png" alt="remove" />
            </button>
          )}
        </div>

        {error && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{error}</span>}
        {!error && (
          <span className="block mb-2 text-sm text-gray-400 dark:text-gray-600">{charAllowed - (value.length ?? 0)} characters remaining.</span>
        )}
      </div>
    </>
  );
};
